// @generated by protoc-gen-es v1.2.0 with parameter "target=ts,import_extension=.ts"
// @generated from file protogen/video.proto (package protogen, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { NoteContent } from "./notes_pb.ts";

/**
 * @generated from message protogen.VideoRoom
 */
export class VideoRoom extends Message<VideoRoom> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: string uuid = 2;
   */
  uuid = "";

  /**
   * @generated from field: string hostRef = 3;
   */
  hostRef = "";

  /**
   * @generated from field: repeated string participantRefs = 4;
   */
  participantRefs: string[] = [];

  /**
   * @generated from field: int64 creationSec = 5;
   */
  creationSec = protoInt64.zero;

  /**
   * @generated from field: int64 lastUpdatedSec = 6;
   */
  lastUpdatedSec = protoInt64.zero;

  /**
   * @generated from field: string status = 7;
   */
  status = "";

  /**
   * @generated from field: protogen.VideoRoom.State state = 8;
   */
  state = VideoRoom_State.UNSPECIFIED;

  /**
   * @generated from field: bool transcriptionEnabled = 9;
   */
  transcriptionEnabled = false;

  /**
   * @generated from field: string roomSid = 10;
   */
  roomSid = "";

  constructor(data?: PartialMessage<VideoRoom>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.VideoRoom";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "uuid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "hostRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "participantRefs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "creationSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "lastUpdatedSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "state", kind: "enum", T: proto3.getEnumType(VideoRoom_State) },
    { no: 9, name: "transcriptionEnabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "roomSid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): VideoRoom {
    return new VideoRoom().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): VideoRoom {
    return new VideoRoom().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): VideoRoom {
    return new VideoRoom().fromJsonString(jsonString, options);
  }

  static equals(a: VideoRoom | PlainMessage<VideoRoom> | undefined, b: VideoRoom | PlainMessage<VideoRoom> | undefined): boolean {
    return proto3.util.equals(VideoRoom, a, b);
  }
}

/**
 * @generated from enum protogen.VideoRoom.State
 */
export enum VideoRoom_State {
  /**
   * @generated from enum value: STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: STATE_CREATING = 1;
   */
  CREATING = 1,

  /**
   * @generated from enum value: STATE_ACTIVE = 2;
   */
  ACTIVE = 2,

  /**
   * @generated from enum value: STATE_COMPLETED = 3;
   */
  COMPLETED = 3,

  /**
   * @generated from enum value: STATE_FAILED = 4;
   */
  FAILED = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(VideoRoom_State)
proto3.util.setEnumType(VideoRoom_State, "protogen.VideoRoom.State", [
  { no: 0, name: "STATE_UNSPECIFIED" },
  { no: 1, name: "STATE_CREATING" },
  { no: 2, name: "STATE_ACTIVE" },
  { no: 3, name: "STATE_COMPLETED" },
  { no: 4, name: "STATE_FAILED" },
]);

/**
 * @generated from message protogen.VideoComment
 */
export class VideoComment extends Message<VideoComment> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: string videoRoomRef = 2;
   */
  videoRoomRef = "";

  /**
   * @generated from field: string participantRef = 3;
   */
  participantRef = "";

  /**
   * @generated from field: string participantName = 4;
   */
  participantName = "";

  /**
   * @generated from field: protogen.NoteContent body = 5;
   */
  body?: NoteContent;

  /**
   * @generated from field: int64 timestampSec = 6;
   */
  timestampSec = protoInt64.zero;

  constructor(data?: PartialMessage<VideoComment>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.VideoComment";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "videoRoomRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "participantRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "participantName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "body", kind: "message", T: NoteContent },
    { no: 6, name: "timestampSec", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): VideoComment {
    return new VideoComment().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): VideoComment {
    return new VideoComment().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): VideoComment {
    return new VideoComment().fromJsonString(jsonString, options);
  }

  static equals(a: VideoComment | PlainMessage<VideoComment> | undefined, b: VideoComment | PlainMessage<VideoComment> | undefined): boolean {
    return proto3.util.equals(VideoComment, a, b);
  }
}

